//Library Imports
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
//Local Imports
import { RootState } from "store";
import SentEmailSearch from "../../Campaigns/Emails/Components/SentEmailSearch";
import Action from "./Action";
import { IControls, WFStatus } from "../interfaces";
import { getControlsAPI } from "../actions";
import { CONTROLS_NAMES } from '../constants';
//Style Imports
import styled from "styled-components";



const Controlls: React.FC = () => {
  const controls = useSelector((state: RootState) => state.automation.controls);
  const workflowStatus: WFStatus = useSelector((state: RootState) => state.automation.workflow?.detail?.status);
  const copiedNode = useSelector((state: RootState) => state.automation.workflow.copiedNode);

  useEffect(() => {
    getControlsAPI();
  }, [])

  return (
    <Wrapper>
      <div className="header-sidebar">
        <h4>Actions / Conditions</h4>
        <div className="search-controll-wrapper">
          <SentEmailSearch
            handleSearch={({})}
            reset={({})}
            placeholder="Search actions & Conditions…"
          />
        </div>
      </div>
      <div className="scrollable" >
        <ul>
          {
            controls?.map((control: IControls, index) => {
              return (<li key={control.id}>
                <Action
                  name={control.name}
                  // title={control.title}
                  title={CONTROLS_NAMES[control.name]}
                  controlId={control.id}
                  controlType={control.type}
                  status={workflowStatus}
                  isNodeCopied={copiedNode.hasOwnProperty("nodeId")}
                />
              </li>)
            })
          }
        </ul>
      </div>
    </Wrapper>
  );
};

export default Controlls;

const Wrapper = styled.div`
  width: 100%;
  display: block;
  float: left;
  .header-sidebar{
    background-color:#F7F7F7;
    float: left;
    width: 100%;
    h4{
      color:#424B50;
      font-size:16px;
      font-weight:500;
      padding:20px 16px;
      font-family: "Roboto", sans-serif;
      margin:0;
      border-bottom:1px solid #DADADA;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size:14px;
      }
    }
    .search-controll-wrapper{
      padding:10px;
      float: left;
      width: 100%;
    }
  }
  .scrollable{
    max-height: calc(100vh - 245px);
    background-color:#fff;
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: #001760 transparent;
    width:100%;
    float:left;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      max-height: calc(100vh - 205px);
    }
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: #fff;
      margin-top: 10px;
      margin-bottom: 15px;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #001760;
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
  ul {
    padding: 0px 16px;
    margin: 0;
    list-style: none;
    float:left;
    display:block;
    width:100%;
    li {
      margin: 10px 0;
      padding: 0;
      list-style: none;
    }
  }
`;
